const SUBSCRIPTION_STATUS = [
  { value: 'active', label: 'Aktiv' },
  { value: 'cancelled', label: 'Kunden har opsagt' },
  { value: 'terminated', label: 'Termineret' },
  { value: 'expired', label: 'Prøveperiode udløbet' },
];

export default SUBSCRIPTION_STATUS;
